(() => {
  const validateUpload = (input) => {
    const file = input.files && input.files[0];
    const maxBytes = Number(input.dataset.maxBytes || 10485760);
    const error = input.parentElement.querySelector('[data-bw-upload-error]');
    const tooLarge = Boolean(file && file.size > maxBytes);

    input.classList.toggle('is-invalid', tooLarge);
    input.setCustomValidity(tooLarge ? 'Die Datei darf maximal 10 MB groß sein.' : '');
    if (error) error.hidden = !tooLarge;
    return !tooLarge;
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-bw-upload]')) validateUpload(event.target);
  });

  document.addEventListener('submit', (event) => {
    const input = event.target.querySelector('[data-bw-upload]');
    if (input && !validateUpload(input)) {
      event.preventDefault();
      input.reportValidity();
      input.focus();
    }
  });
})();
